__turbopack_context__.v({
  "activePage": "ThreatLibraryPage-module-scss-module__YQEuFW__activePage",
  "classiciations": "ThreatLibraryPage-module-scss-module__YQEuFW__classiciations",
  "closeButton": "ThreatLibraryPage-module-scss-module__YQEuFW__closeButton",
  "container": "ThreatLibraryPage-module-scss-module__YQEuFW__container",
  "description": "ThreatLibraryPage-module-scss-module__YQEuFW__description",
  "desktopSidebarWrapper": "ThreatLibraryPage-module-scss-module__YQEuFW__desktopSidebarWrapper",
  "ellipsis": "ThreatLibraryPage-module-scss-module__YQEuFW__ellipsis",
  "header": "ThreatLibraryPage-module-scss-module__YQEuFW__header",
  "lastUpdated": "ThreatLibraryPage-module-scss-module__YQEuFW__lastUpdated",
  "mainContent": "ThreatLibraryPage-module-scss-module__YQEuFW__mainContent",
  "mobileFilterButton": "ThreatLibraryPage-module-scss-module__YQEuFW__mobileFilterButton",
  "mobilePanelOpen": "ThreatLibraryPage-module-scss-module__YQEuFW__mobilePanelOpen",
  "mobilePanelWrapper": "ThreatLibraryPage-module-scss-module__YQEuFW__mobilePanelWrapper",
  "nextPage": "ThreatLibraryPage-module-scss-module__YQEuFW__nextPage",
  "noResults": "ThreatLibraryPage-module-scss-module__YQEuFW__noResults",
  "pageButton": "ThreatLibraryPage-module-scss-module__YQEuFW__pageButton",
  "paginationControls": "ThreatLibraryPage-module-scss-module__YQEuFW__paginationControls",
  "prevPage": "ThreatLibraryPage-module-scss-module__YQEuFW__prevPage",
  "refLink": "ThreatLibraryPage-module-scss-module__YQEuFW__refLink",
  "references": "ThreatLibraryPage-module-scss-module__YQEuFW__references",
  "resultsArea": "ThreatLibraryPage-module-scss-module__YQEuFW__resultsArea",
  "resultsSummary": "ThreatLibraryPage-module-scss-module__YQEuFW__resultsSummary",
  "threatCard": "ThreatLibraryPage-module-scss-module__YQEuFW__threatCard",
  "threatHeader": "ThreatLibraryPage-module-scss-module__YQEuFW__threatHeader",
  "threatLibraryPage": "ThreatLibraryPage-module-scss-module__YQEuFW__threatLibraryPage",
  "threatName": "ThreatLibraryPage-module-scss-module__YQEuFW__threatName",
});
